function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { addLocaleData, IntlProvider } from 'react-intl';
import * as en from 'react-intl/locale-data/en';
import * as ja from 'react-intl/locale-data/ja';
addLocaleData([].concat(_toConsumableArray(ja), _toConsumableArray(en)));
export var locales = {
  en: require('../../locales/en.yml'),
  ja: require('../../locales/ja.yml')
};

var IntlMessage = /*#__PURE__*/function () {
  function IntlMessage(locale) {
    _classCallCheck(this, IntlMessage);

    if (locale) {
      this.intl = this.makeIntlInstance(locale);
    }
  }

  _createClass(IntlMessage, [{
    key: "format",
    value: function format(messageDescriptor, values) {
      return this.intl.formatMessage.bind(this.intl)(messageDescriptor, values);
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(locale) {
      this.intl = this.makeIntlInstance(locale);
    }
  }, {
    key: "makeIntlInstance",
    value: function makeIntlInstance(locale) {
      var messages = locales["ja"];

      switch (locale) {
        case "en":
          messages = locales["en"];
          break;
      }

      var intlProvider = new IntlProvider({
        locale: locale,
        messages: messages
      });
      return intlProvider.getChildContext().intl;
    }
  }]);

  return IntlMessage;
}();

export { IntlMessage as default };